module.exports = __webpack_public_path__ + "img/elo.6e0d022b.svg";